export default "__VITE_ASSET__54d13a80__"